import React from "react";
import "./Page.less";
import "./Program.less";
import programStrategyModelPicture from "../../img/data/programStrategyModelPicture.svg";
import BackBtn from '../components/UI/BackBtn';

export default function ProgramStrategy() {
  return (
    <section className="page program-page program-page-strategy">
      <div className="container">
        <BackBtn />
        <h2>Стратегия УрФУ в области технологического лидерства</h2>
        <div className="program">
          Приоритет в реализации стратегического технологического лидерства УрФУ
          – локализация цепочек создания и внедрения критических и сквозных
          технологий по ключевым направлениям научно-технологического развития
          УрФУ сфокусированных на решении задач соответствующих национальных
          проектов технологического лидерства за счет решение следующих задач:
          <ol>
            <li>
              Создание центров компетенций технологического лидерства и
              реализации стратегических технологических проектов: 
              <br />
              – <strong>Замыкание
              ядерно-топливного цикла и функциональные материалы для атомной
              промышленности. </strong><br/>
              Целью проекта является разработка комплекса
              высокоэффективных и ресурсосберегающих технологий по замыканию
              ядерно-топливного цикла и производству востребованных в
              современных условиях функциональных материалов (танталовые
              конденсаторы, магнитотвердые материалы, редкометальная керамика и
              т.д.).
              <br />
              – <strong>Многоцелевые силовые установки.</strong><br/>Целью проекта является
              обеспечение технологического суверенитета РФ в области
              перспективных отечественных двигателей внутреннего сгорания
              различного назначения (БПЛА, наземный и водный транспорт,
              промышленные установки и т.д.), а также гибридных силовых
              установок. Локализация изготовления компонентов двигателей на
              предприятиях России и дружественных стран. Снижение вредных
              выбросов и повышение эффективности при эксплуатации транспорта и
              промышленных установок.
              <br />
              – <strong>Фармпрепараты, технологии и материалы для здоровьесбережения.</strong><br/>
              Целью проекта является решение проблемы здоровьесбережения за счет
              разработки перспективных фармацевтических препаратов, материалов и
              устройств для диагностики здоровья.
              <br />
              – <strong>Металлургия в экономике замкнутого цикла. </strong><br/>Целью проекта является
              создание и внедрение комплексных технологий переработки рудного и
              техногенного металлургического сырья, получения
              высокотехнологичной металлопродукции, проектирование и поставка
              металлургического оборудования, роботизация и цифровизация
              действующего и вновь создаваемого производства.
              <br />
              – <strong>Искусственный интеллект и цифровые производственные
              системы. </strong><br/>
              Целю проекта являются разработка и внедрение суверенных
              технологий искусственного интеллекта, и их приложений,
              обеспечивающих переход к цифровым безлюдным производствам через
              системную интеграцию программного обеспечения, аппаратных решений
              и робототехнических комплексов на предприятиях обрабатывающей
              промышленности, топливно-энергетического комплекса и медицинских
              учреждениях для повышения эффективности, производительности и
              качества продукции и услуг.
            </li>
            <li>
              Формирование новой модели управления исследованиями и
              разработками, от фундаментальных исследований до серийного
              производства, сокращающей время перехода от идей к коммерческим
              решениям. Обеспечение условий взаимодействия и совместной работы
              УрФУ с отраслевыми лидерами по выбранным направлениям и
              региональной инновационной инфраструктурой.
            </li>
            <li>
              Создание новой образовательной модели через реализацию трех
              инициатив, направленных на опережающую подготовку инженерных
              кадров:
              <ul>
                <li>
                  Технологии и кадры новой атомной энергетики замкнутого
                  ядерного топливного цикла;
                </li>
                <li>Уральская инженерная школа;</li>
                <li>ИТ образование и разработки для цифровой индустрии.</li>
              </ul>
            </li>
          </ol>
          <h3 style={{paddingTop: 32, marginBottom: 0}}>Модель организации полного инновационного цикла от научных исследований (УГТ 1-3) до серийного производства (УГТ 9)</h3>
          <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 32, marginTop: '-120px'}}>
            <img style={{width: '100%'}} className="program-picture" src={programStrategyModelPicture} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}
